import { useStaticQuery, graphql } from "gatsby";
import { ProductFields } from "./fragments";

export const UseGetProductsByEnvironment = () => {
  const data = useStaticQuery(graphql`
    query getAllProductsByEnvironment {
      Bush: shopifyCollection(handle: { eq: "bush" }) {
        ...ProductFields
      }
      Alpine: shopifyCollection(handle: { eq: "alpine" }) {
        ...ProductFields
      }
      Rural: shopifyCollection(handle: { eq: "rural" }) {
        ...ProductFields
      }
      Ocean: shopifyCollection(handle: { eq: "seabuck" }) {
        ...ProductFields
      }
    }
  `);
  return data;
};
